/* eslint-disable */
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Login from '@/views/Login'
import MainContainer from '@/views/MainContainer/MainContainer.page.vue'
import ChangePasswordPage from '@/views/MainContainer/ChangePassword.page.vue'
import PasswordChangedPage from '@/views/MainContainer/PasswordChanged.page.vue'
import ForbiddenPage from '@/views/MainContainer/Forbidden.page.vue'
import UnauthorizedPage from '@/views/MainContainer/Unauthorized.page.vue'
import ReportsPage from '@/views/MainContainer/Reports/Reports.page.vue'
import ReportViewer from "@/views/MainContainer/Reports/ReportViewer"
import UsersPage from '@/views/MainContainer/Users/UsersPage'
import UserDetailsPage from '@/views/MainContainer/Users/UserDetails/UserDetailsPage'
import Suppliers from "@/views/MainContainer/Suppliers/Suppliers";
import CorpUsers from "@/views/MainContainer/CorpUsers/CorpUser";
import CorpUserForm from "@/views/MainContainer/CorpUsers/CorpUserForm";
import { SrsCodesRoutes } from '../views/MainContainer/SrsCodes/SrsCodes.routes'
import { TokenGuard } from './guards/Token.guard'
import { PasswordChangeGuard } from './guards/PasswordChange.guard'
import { PasswordChangeVerifyGuard } from './guards/PasswordChangeVerify.guard'
import ResetPassword from '@/views/ResetPassword';
import { RoleGuard } from './guards/Role.guard'
import { RoleEnum } from '../models/Role.enum'

Vue.use(VueRouter)

/**
 * @type { RouteConfig[] }
 */
const routes = [

  {
    path: '/',
    redirect: "/login",
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: ResetPassword
  },
  {
    path: '/app',
    component: MainContainer,
    beforeEnter: TokenGuard,
    children: [
      {
        path: 'changePassword',
        component: ChangePasswordPage,
        beforeEnter: PasswordChangeVerifyGuard,
      },
      {
        path: 'passwordChanged',
        component: PasswordChangedPage,
      },
      {
        path: 'forbidden',
        component: ForbiddenPage,
      },
      {
        path: 'unauthorized',
        component: UnauthorizedPage,
      },
      {
        path: 'reports',
        component: ReportsPage,
        beforeEnter: PasswordChangeGuard,
      },
      {
        path: 'reports/:reportName',
        name: 'ReportViewer',
        component: ReportViewer,
      },
      ...SrsCodesRoutes,
      {
        path: 'suppliers',
        name: 'Suppliers',
        component: Suppliers,
      },
      {
        path: 'users',
        name: 'Users',
        component: UsersPage,
        beforeEnter: RoleGuard(RoleEnum.admin),
      },
      {
        path: 'users/new',
        component: UserDetailsPage,
        beforeEnter: RoleGuard(RoleEnum.admin),
      },
      {
        path: 'users/:id',
        component: UserDetailsPage,
        beforeEnter: RoleGuard(RoleEnum.admin),
      },
      {
        path: 'corpUsers',
        name: 'CorpUsers',
        component: CorpUsers,
        children: []
      },
      {
        path: 'corpUser/details/:id',
        name: 'CorpUserDetails',
        component: CorpUserForm
      },
      {
        path: 'corpUserForm/add',
        name: 'CorpUserForm',
        component: CorpUserForm
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

export { navigation } from './navigation'
export { AdminRouteItems } from './routeItems'
